module.exports = __webpack_public_path__ + "media/images/profitwell-6bc4287319c495412c7444459e7e50c3.svg";